import { jsx as _jsx } from "react/jsx-runtime";
import { Navigate, Outlet, useLocation } from "react-router-dom";
import { useAuth } from "@sal/authentication.react";
export const AuthenticatedRoute = (props) => {
    const auth = useAuth();
    const location = useLocation();
    if (!auth.isLoggedIn) {
        return _jsx(Navigate, { to: "/Login", replace: true, state: { from: location } });
    }
    let hasAccess;
    if (!props.securityContext || !props.securityContextPermission) {
        hasAccess = true;
    }
    else if (auth.userHasPermission(props.securityContext, props.securityContextPermission)) {
        hasAccess = true;
    }
    else {
        hasAccess = false;
    }
    if (!hasAccess) {
        return _jsx(Navigate, { to: "/NotFound", replace: true });
    }
    return props.children ? props.children : _jsx(Outlet, {});
};
